<template>
  <div class="c-alert c-alert--danger">
    <div v-html="failConfirmation"></div>
  </div>
  <div class="o-form">
    <Contact />
    <div class="o-input">
      <label class="o-input__label">Nog te betalen</label>
      <div class="o-input__controls">
        <p>{{ formatCurrency(totalCost) }} euro</p>
      </div>
    </div>
  </div>
  <footer class="c-container__footer">
    <div class="o-toolbar">
      <div class="o-toolbar__left"><button type="button" class="c-button c-button--default" @click="goBack">Terug</button></div>
      <div class="o-toolbar__right"><button type="button" class="c-button c-button--primary" @click="tryAgain">Probeer opnieuw te betalen</button></div>
    </div>
  </footer>
</template>

<script>
import { formatCurrency } from "@/infrastructure/utilities";

import Contact from "@/components/order/Contact";

import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed } from "vue";

export default {
  components: { Contact },
  setup() {
    const store = useStore();
    const router = useRouter();

    const totalCost = computed(() => store.getters["orders/totalCostWithDiscount"]);

    return {
      failConfirmation: store.state.webshop.failConfirmation,
      totalCost,
      formatCurrency,

      goBack() {
        router.push({ name: "besteloverzicht" });
      },
      tryAgain() {
        router.push({ name: "betaalformulier" });
      },
    };
  },
};
</script>
